// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2F2gq","header":"PatientQuestionnaire_header__2Gb5Q","info":"PatientQuestionnaire_info__2zHfe"};